// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__15By9","productName":"Table_productName__2fJD-"};